export function ColorBox({ clrA }) {
  const styles = {
    backgroundColor: clrA,
    height: "50px",
    width: "200px",
    margin: "10px 0px",
  };
  return <div style={styles}></div>;
}
